import React from 'react';

export default function CmPagination({ page, total, perPage, onChange, onPerPageChange }) {
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const from = total === 0 ? 0 : (page - 1) * perPage + 1;
  const to = Math.min(page * perPage, total);

  const pages = [];
  const maxButtons = 5;
  let start = Math.max(1, page - Math.floor(maxButtons / 2));
  let end = Math.min(totalPages, start + maxButtons - 1);
  if (end - start < maxButtons - 1) {
    start = Math.max(1, end - maxButtons + 1);
  }
  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return (
    <div className="cm-pagination">
      <div className="cm-pagination__info">
        <span>Mostrando {from}-{to} de {total}</span>
      </div>

      <div className="cm-pagination__right">
        {onPerPageChange && (
          <div className="cm-pagination__per-page">
            <span className="cm-pagination__per-page-label">Por página:</span>
            <select
              className="cm-pagination__select"
              value={perPage}
              onChange={(e) => onPerPageChange(Number(e.target.value))}
            >
              {[10, 20, 30, 60].map((n) => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
          </div>
        )}

        <div className="cm-pagination__buttons">
          <button
            className="cm-pagination__btn"
            disabled={page <= 1}
            onClick={() => onChange(1)}
          >
            &laquo;
          </button>
          <button
            className="cm-pagination__btn"
            disabled={page <= 1}
            onClick={() => onChange(page - 1)}
          >
            &lsaquo;
          </button>

          {pages.map((p) => (
            <button
              key={p}
              className={`cm-pagination__btn${p === page ? ' cm-pagination__btn--active' : ''}`}
              onClick={() => onChange(p)}
            >
              {p}
            </button>
          ))}

          <button
            className="cm-pagination__btn"
            disabled={page >= totalPages}
            onClick={() => onChange(page + 1)}
          >
            &rsaquo;
          </button>
          <button
            className="cm-pagination__btn"
            disabled={page >= totalPages}
            onClick={() => onChange(totalPages)}
          >
            &raquo;
          </button>
        </div>
      </div>
    </div>
  );
}
